import { createStore } from "vuex";
import { auth } from "./auth.module";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-gradient-dark",
    isRTL: false,
    color: "info",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: false,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    // get-merchant-setting getWaBalanceByAdminMerchant >= 1 (SignIn forgot passcode reads it)
    hasWaBalance: false,
  },
  modules: {
    auth,
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    // Like toggleEveryDisplay but keeps the sidenav mounted (MBR Home: bottom nav ACCOUNT opens it)
    toggleNavbarOnly(state) {
      state.showNavbar = !state.showNavbar;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    color(state, payload) {
      state.color = payload;
    },
    merchantCode(state, payload) {
      state.merchantCode = payload;
    },
    merchantLogo(state, payload) {
      state.merchantLogo = payload;
    },
    backgroundColor(state, payload) {
      state.backgroundColor = payload;
    },
    labelColor(state, payload) {
      state.labelColor = payload;
    },
    buttonColor(state, payload) {
      state.buttonColor = payload;
    },
    buttonTextColor(state, payload) {
      state.buttonTextColor = payload;
    },
    hasWaBalance(state, payload) {
      state.hasWaBalance = payload;
    },
  },
  actions: {
    setColor({ commit }, payload) {
      commit("color", payload);
    },
    setMerchantCode({ commit }, payload) {
      commit("merchantCode", payload);
    },
    setMerchantLogo({ commit }, payload) {
      commit("merchantLogo", payload);
    },
    setBackgroundColor({ commit }, payload) {
      commit("backgroundColor", payload);
    },
    setLabelColor({ commit }, payload) {
      commit("labelColor", payload);
    },
    setButtonColor({ commit }, payload) {
      commit("buttonColor", payload);
    },
    setButtonTextColor({ commit }, payload) {
      commit("buttonTextColor", payload);
    },
    setHasWaBalance({ commit }, payload) {
      commit("hasWaBalance", payload);
    },
  },
  getters: {},
});
